import styled from 'styled-components';

import { ContainerProps } from './types';

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ active, theme, color }) =>
    active ? theme.colors.primary.base : color};
  transform: ${({ rotate }) => (rotate ? `rotate(${rotate}deg)` : 'none')};
  transition: transform 0.2s ease-in-out;

  > svg {
    transition: color 0.3s, transform 0.2s ease-in-out;
    &:hover {
      color: ${(props) => props.colorOnHover};
    }
  }
`;
